import Parse from 'html-react-parser';

function BMP20242(props) {
    let svgCode =
        `<svg width="1744" height="2176" viewBox="0 0 1744 2176" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="1744" height="2176" fill="${props.backgroundFill}"/>
    <rect x="2" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="6" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="4" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="4" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="30" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="40" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1088" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1088" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1088" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1088" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1094" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1092" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1092" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1088" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1088" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1118" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1128" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="272" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="272" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="272" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="272" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="278" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="276" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="276" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="272" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="272" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="302" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="312" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1360" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1360" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1360" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1360" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1366" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1364" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1364" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1360" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1360" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1390" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1400" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="544" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="544" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="544" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="544" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="550" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="548" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="548" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="544" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="544" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="574" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="584" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1632" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1632" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1632" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1632" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1638" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1636" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1636" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1632" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1632" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1662" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1672" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="816" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="816" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="816" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="816" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="822" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="820" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="820" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="816" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="816" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="846" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="856" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1904" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1904" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1904" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1904" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1910" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1908" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1908" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1904" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1904" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1934" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1944" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="68" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="68" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="68" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="68" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="74" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="72" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="72" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="68" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="68" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="98" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="108" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1156" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1156" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1156" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1156" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1162" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1160" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1160" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1156" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1156" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1186" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1196" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="340" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="340" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="340" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="340" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="346" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="344" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="344" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="340" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="340" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="370" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="380" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1428" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1428" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1428" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1428" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1434" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1432" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1432" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1428" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1428" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1458" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1468" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="612" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="612" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="612" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="612" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="618" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="616" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="616" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="612" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="612" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="642" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="652" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1700" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1700" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1700" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1700" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1706" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1704" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1704" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1700" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1700" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1730" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1740" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="884" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="884" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="884" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="884" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="890" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="888" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="888" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="884" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="884" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="914" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="924" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1972" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1972" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1972" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1972" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1978" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1976" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1976" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1972" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1972" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="2002" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="2012" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="136" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="136" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="136" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="136" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="142" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="140" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="140" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="136" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="136" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="166" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="176" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1224" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1224" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1224" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1224" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1230" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1228" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1228" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1224" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1224" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1254" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1264" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="408" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="408" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="408" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="408" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="414" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="412" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="412" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="408" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="408" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="438" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="448" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1496" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1496" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1496" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1496" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1502" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1500" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1500" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1496" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1496" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1526" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1536" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="680" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="680" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="680" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="680" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="686" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="684" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="684" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="680" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="680" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="710" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="720" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1768" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1768" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1768" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1768" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1774" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1772" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1772" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1768" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1768" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1798" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1808" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="952" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="952" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="952" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="952" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="958" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="956" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="956" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="952" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="952" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="982" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="992" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="2040" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="2040" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="2040" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="2040" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="2046" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="2044" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="2044" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="2040" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="2040" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="2070" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="2080" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="204" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="204" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="204" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="204" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="210" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="208" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="208" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="204" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="204" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="234" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="244" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1292" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1292" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1292" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1292" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1298" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1296" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1296" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1292" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1292" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1322" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1332" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="476" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="476" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="476" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="476" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="482" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="480" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="480" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="476" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="476" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="506" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="516" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1564" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1564" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1564" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1564" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1570" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1568" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1568" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1564" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1564" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1594" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1604" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="748" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="748" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="748" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="748" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="754" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="752" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="752" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="748" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="748" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="778" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="788" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1836" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1836" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1836" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1836" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1842" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1840" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1840" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1836" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1836" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1866" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1876" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="1020" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="1020" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="1020" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="1020" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="1026" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="1024" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="1024" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="1020" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="1020" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="1050" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="1060" width="284" height="4" fill="${props.highlightColourB}"/>
    <rect x="2" y="2108" width="1736" height="64" fill="${props.backgroundFill}"/>
    <rect x="2" y="2108" width="185" height="64" fill="${props.highlightColourB}"/>
    <rect x="709" y="2108" width="253" height="64" fill="${props.highlightColourB}"/>
    <rect x="978" y="2108" width="72" height="64" fill="${props.highlightColourB}"/>
    <rect x="640" y="2114" width="52" height="52" rx="3" fill="${props.highlightColourB}"/>
    <rect x="206" y="2112" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1376" y="2112" width="56" height="56" rx="3" fill="${props.paramFill}"/>
    <rect x="1066" y="2108" width="92" height="64" fill="${props.highlightColourB}"/>
    <rect x="1174" y="2108" width="182" height="64" fill="${props.highlightColourB}"/>
    <rect x="1472" y="2138" width="238" height="4" fill="${props.highlightColourB}"/>
    <rect x="312" y="2148" width="284" height="4" fill="${props.highlightColourB}"/>
    </svg>`

    props.svgReturn(77, svgCode, "bmp00242", 1744, 2176);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "570px",
        top: "50px",
        left: "0px",
        display: props.display
        // transform: "scale(2.4)"
    }

    const inStyle = {
        marginTop: "0px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
                {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20242;